var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkArrowBlack = function SvgLinkArrowBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 9
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "link-arrow-black_svg__a",
    d: "M8.94 4 5.822.884 6.53.177l4.354 4.353L6.53 8.884l-.707-.707L9 5H0V4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.94 4 5.822.884 6.53.177l4.354 4.353L6.53 8.884l-.707-.707L9 5H0V4z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "link-arrow-black_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#link-arrow-black_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#link-arrow-black_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15-15h40v40h-40z"
  })))));
};
export default SvgLinkArrowBlack;